import(/* webpackMode: "eager" */ "/app/components/AgentCard.js");
import(/* webpackMode: "eager" */ "/app/components/BackButton.js");
import(/* webpackMode: "eager" */ "/app/components/ContactCardProject.js");
import(/* webpackMode: "eager" */ "/app/components/CurrencySymbol.js");
import(/* webpackMode: "eager" */ "/app/components/FooterPopularLinks.js");
import(/* webpackMode: "eager" */ "/app/components/HtmlComponent.js");
import(/* webpackMode: "eager" */ "/app/components/LdJson/BreadcrumbsNewDevelopmentsLdJson.js");
import(/* webpackMode: "eager" */ "/app/components/LdJson/PropertyLdJson.js");
import(/* webpackMode: "eager" */ "/app/components/LinkComponent.js");
import(/* webpackMode: "eager" */ "/app/components/Location.js");
import(/* webpackMode: "eager" */ "/app/components/Nav.js");
import(/* webpackMode: "eager" */ "/app/components/ProjectContact.js");
import(/* webpackMode: "eager" */ "/app/components/ProjectProperties.js");
import(/* webpackMode: "eager" */ "/app/components/PropertyContact.js");
import(/* webpackMode: "eager" */ "/app/components/PropertyFloorplansGallery.js");
import(/* webpackMode: "eager" */ "/app/components/PropertyGalleryMulti.js");
import(/* webpackMode: "eager" */ "/app/components/ShareButton.js");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-no-ssr.js")